var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaterCart = function SvgWaterCart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_3047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2246 5.10303L55.2236 7.47119H54.9473V11.3296H56.2178V24.9243H54.9473V41.606H56.2178V55.2007H54.9346C54.7401 59.0383 52.2672 62.2722 48.8428 63.5835L52.1094 70.1606H44.7246L47.8682 63.8989C47.0957 64.1019 46.2853 64.2114 45.4492 64.2114H36.6582L39.6143 70.1606H32.2285L35.2158 64.2114H26.5498C25.6606 64.2114 24.8006 64.0865 23.9844 63.8579L27.1143 70.1606H19.7305L23.0527 63.5435C19.6823 62.207 17.2579 58.9993 17.0654 55.2007H15.7812V41.606H17.0527V24.9243H15.7812V11.3296H17.0527V7.47119H16.7812L16.7754 5.10303L18.4922 2.85205H53.5078L55.2246 5.10303Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14814_3047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.16 -79.9565H-282.588V172.72H354.16V-79.9565Z",
    stroke: "black",
    strokeWidth: 2.95113
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0884 5.27297L53.3714 3.02148H53.3697H18.3675H18.3557L16.6387 5.27297L16.6446 7.64134H55.0867L55.0884 5.27297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3064 62.9365L19.5938 70.3305H26.9775L23.3064 62.9365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8045 62.9365L32.0918 70.3305H39.4773L35.8045 62.9365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3005 62.9365L44.5879 70.3305H51.9725L48.3005 62.9365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0814 41.7754H15.6445V55.3707H56.0814V41.7754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0814 11.4995H15.6445V25.094H56.0814V11.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6056 4.90771H43.2488V6.40277H53.9793V54.8825C53.9793 59.6692 50.0981 63.5496 45.3122 63.5496H26.4135C21.6276 63.5496 17.748 59.6692 17.748 54.8825V6.40277H28.6073L28.6056 4.90771Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8625 50.4959C38.7863 50.4959 41.1566 48.1257 41.1566 45.2018C41.1566 42.278 38.7863 39.9077 35.8625 39.9077C32.9386 39.9077 30.5684 42.278 30.5684 45.2018C30.5684 48.1257 32.9386 50.4959 35.8625 50.4959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0405 6.5249H18.2871V21.3662H29.0405V6.5249Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.831727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6265 6.5249H42.873V21.3662H53.6265V6.5249Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.831727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2051 62.9758V21.7969H53.6415V56.9625C52.7512 59.203 52.2252 60.9361 48.2051 62.9758Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4166 62.9758V21.7969H17.9785V56.9625C18.8679 59.203 19.3965 60.9361 23.4166 62.9758Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5234 21.3877H54.6212",
    stroke: "black",
    strokeWidth: 0.831727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4312 4.95557H43.48V6.40234H53.9793V54.882C53.9793 59.6688 50.0981 63.5492 45.3122 63.5492H26.4135C21.6276 63.5492 17.748 59.6688 17.748 54.882V6.40234H28.4337L28.4312 4.95557Z",
    stroke: "black",
    strokeWidth: 1.66345
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8963 11.0234H20.3164V20.9747H28.8963V11.0234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1821 12.1934H21.3379V14.7693H28.1821V12.1934Z",
    fill: "#BDBDBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_3047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14814_3047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.7412,
    height: 72,
    fill: "white",
    transform: "translate(13.1289 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaterCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "water-cart.0fc23b2109c835c4a51f86c2bea7d654.svg";